module.exports = __webpack_public_path__ + "static/img/title2.44cddc09.png";